import React from "react";
import {
  Container,
  Grid,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
  IconButton,
  Divider,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import Colorapps from "../configcss/color";
import lihs from "./images/lihs.png";
import "./Navbar.css";

const Footer = () => {
  const theme = useTheme();
  const isMatchsm = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container
      maxWidth="xxl"
      sx={{
        backgroundColor: "#333",
        color: "#fff",
        py: 4,
        px: isMatchsm ? 2 : 4,
        borderTop: `2px solid ${Colorapps.themeprimary}`,
      }}
    >
      {/* Footer Header with Logo */}
      <Grid
        container
        spacing={3}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <div style={{ marginLeft: "50px" }}>
            <img src={lihs} alt="lihs" className="logo-footer" />
          </div>
        </Grid>
        <Grid item>
          <Stack direction="row" spacing={2}>
            <IconButton
              sx={{
                color: "#fff",
                "&:hover": { color: Colorapps.backgroundtheme },
              }}
              onClick={() => window.open("https://twitter.com/", "_blank")}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              sx={{
                color: "#fff",
                "&:hover": { color: Colorapps.backgroundtheme },
              }}
              onClick={() => window.open("https://instagram.com/", "_blank")}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              sx={{
                color: "#fff",
                "&:hover": { color: Colorapps.backgroundtheme },
              }}
              onClick={() => window.open("https://facebook.com/", "_blank")}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              sx={{
                color: "#fff",
                "&:hover": { color: Colorapps.backgroundtheme },
              }}
              onClick={() => window.open("https://wa.me/", "_blank")}
            >
              <WhatsAppIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>

      {/* Footer Sections */}
      <Grid
        container
        spacing={3}
        mt={4}
        sx={{ textAlign: isMatchsm ? "center" : "left" }}
      >
        {/* Quick Links */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Quick Links
          </Typography>
          <Stack spacing={1}>
            <Typography>Home</Typography>
            <Typography>About Us</Typography>
            <Typography>Services</Typography>
            <Typography>Contact</Typography>
          </Stack>
        </Grid>

        {/* Contact Info */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Contact Info
          </Typography>
          <Stack spacing={1}>
            <Typography>Email: info@example.com</Typography>
            <Typography>Phone: +123 456 7890</Typography>
            <Typography>Address: 123 Main Street, City</Typography>
          </Stack>
        </Grid>

        {/* Newsletter */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Subscribe to our Newsletter
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Get the latest updates directly to your inbox.
          </Typography>
          <Stack direction="row" spacing={1}>
            <input
              type="email"
              placeholder="Your email"
              style={{
                padding: "8px",
                width: "100%",
                borderRadius: "5px",
                border: "none",
                backgroundColor: "#444",
                color: "#fff",
              }}
            />
          </Stack>
        </Grid>

        {/* Legal Information */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Legal
          </Typography>
          <Stack spacing={1}>
            <Typography>Privacy Policy</Typography>
            <Typography>Terms & Conditions</Typography>
            <Typography>Cookie Policy</Typography>
          </Stack>
        </Grid>
      </Grid>

      {/* Divider and Copyright */}
      <Divider sx={{ my: 4, borderColor: "#555" }} />
      <Typography textAlign="center" variant="body2" sx={{ fontSize: "14px" }}>
        Copyright © 2024. All rights reserved.
      </Typography>
    </Container>
  );
};

export default Footer;
